<template>
  <q-card class="form-card">
    <q-card-section class="row items-center q-pb-none">
      <div class="text-h6">{{ data.title }}</div>
      <q-space />
      <q-btn icon="close" flat round dense @click="closeModal" />
    </q-card-section>

    <q-card-section>
      <q-form @submit="onSubmit" class="form">
        <div class="form__item">
          <CustomInput 
            label="Номер этажа" 
            :value="formData.level_num"
            @change_input="(value) => onChange('level_num', value)" 
            required 
          />
        </div>
        <div class="form__item">
          <CustomDate 
            label="Дата начала" 
            :value="formData.level_date_start"
            @change_date="(value) => onChange('level_date_start', value)"
            :minDate="workGroupDateStart"
            :maxDate="workGroupDateEnd"
          />
        </div>
        <div class="form__item">
          <CustomDate 
            label="Дата окончания" 
            :value="formData.level_date_end"
            @change_date="(value) => onChange('level_date_end', value)"
            :minDate="effectiveMinDateEnd"
            :maxDate="workGroupDateEnd"
            :default-value="defaultValueEndDate"
          />
        </div>
        <CustomModalFooter :btn-loading="loading" />
      </q-form>
    </q-card-section>
  </q-card>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomDate from "@/components/form/CustomDate";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";

export default {
  name: "EditWorkGroupLevel",
  components: { CustomModalFooter, CustomInput, CustomDate },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        work_group_level_id: this.data?.body?.work_group_level_id || null,
        work_group_id: this.data?.body?.work_group_id || null,
        level_num: this.data?.body?.level_num || '',
        level_date_start: this.data?.body?.level_date_start || '',
        level_date_end: this.data?.body?.level_date_end || '',
      }
    }
  },
  computed: {
    workGroupDateStart() {
      return this.data?.body?.work_group_date_start || null;
    },
    workGroupDateEnd() {
      return this.data?.body?.work_group_date_end || null;
    },
    effectiveMinDateEnd() {
      return this.formData.level_date_start || this.workGroupDateStart;
    },
    defaultValueEndDate() {
      const start_ = this.formData.level_date_start;
      if (!start_ || start_.length < 10) return undefined;
      const parts_ = start_.split('.');
      if (parts_.length !== 3) return undefined;
      const d_ = new Date(parseInt(parts_[2], 10), parseInt(parts_[1], 10) - 1, parseInt(parts_[0], 10));
      d_.setDate(d_.getDate() + 1);
      const day_ = String(d_.getDate()).padStart(2, '0');
      const month_ = String(d_.getMonth() + 1).padStart(2, '0');
      return `${day_}.${month_}.${d_.getFullYear()}`;
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
  setup() {
    const { closeModal } = useAppStore();
    return { closeModal };
  },
}
</script>

<style scoped>
.form-card {
  min-width: 500px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>

